export function formatDate(dateString, format) {
  let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  if (format === undefined) { format = options }
  const date = new Date(dateString).toLocaleString(undefined, format);
  return date
};